import { AppDispatch, getClientOrganizationListRequest, updateOrganization, updateOrganizationClear, updateOrganizationRequest } from "@src/redux/index";
import { Button } from "antd";
import { log } from "console";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector} from "react-redux";

interface SlaAgreementDisableProps {
  onCancel: () => void;  
  name?:string;
  client?: {
    name?: string;
    id?: string;
  };
}

const SlaAgreementDisable: React.FC<SlaAgreementDisableProps> = ({ onCancel, client ,name}) => { 
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const{result:updateOrgResult,loading:updateOrgLoading}= useSelector(updateOrganization)


  useEffect(()=>{
    if(updateOrgResult?.status === "success"){
      onCancel();
      toast.success(t("disable_sla"));
      dispatch(updateOrganizationClear());

      dispatch(
        getClientOrganizationListRequest({
          filter: {
           
          },
          pagination: {
            pageNumber: pageNumber,
            pageLimit: pageLimit,
          },
          sort: [{
            field: "name",
            order: "asc",
          }],
        })
      );
    }
  },[updateOrgResult?.status])

  const onEnableSla = () => {
    dispatch(updateOrganizationRequest({
      id:client?.id || "",
      data:{
        requireSlaAcceptance:false
      }
    }))
  
    };
  return (
    <div>
       <p>
        {`Are you sure you want to Disable need for SLA Acceptance for `}
        <strong>{client?.name}</strong> 
        {`?`}
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Button style={{ marginRight: "10px" }} onClick={onCancel}>{t("cancel")}</Button>
        <Button type="primary" onClick={onEnableSla} loading={updateOrgLoading}>{t("change")}</Button>
      </div>
    </div>
  );
};

export default SlaAgreementDisable;
